"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReclassifyProductCell = void 0;
const react_1 = require("react");
const use_reclassify_hook_1 = require("../../../../../hooks/reclassify/use-reclassify.hook");
/**
 * Process-row-update helper for the classification product type cell.
 * Reclassifies a single product by ID when the category value changes.
 */
const useReclassifyProductCell = ({ selectedTreeNodePath, onSuccess, onError, }) => {
    const { reclassify, isLoading } = (0, use_reclassify_hook_1.useReclassify)({ selectedTreeNodePath });
    const reclassifyProductCell = (0, react_1.useCallback)((productId, targetCategory, previousCategory) => __awaiter(void 0, void 0, void 0, function* () {
        if (targetCategory === previousCategory) {
            return;
        }
        try {
            yield reclassify({ filter: { product: { id: { in: [productId] } } }, targetCategory });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
        catch (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
            throw error;
        }
    }), [onError, onSuccess, reclassify]);
    return {
        reclassifyProductCell,
        isLoading,
    };
};
exports.useReclassifyProductCell = useReclassifyProductCell;
